import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultichannelActionValueAfterDuration
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionValueAfterDuration/SelectMultichannelActionValueAfterDuration'
import SelectMultichannelActionValueAfterDurationIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionValueAfterDuration/SelectMultichannelActionValueAfterDuration'
import { saveActionStateDescription, saveActionDurationValueAfter } from '@app/actions/scenes/currentSceneCreating'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView
  ? withStyles(SelectMultichannelActionValueAfterDurationIOS) : withStyles(SelectMultichannelActionValueAfterDuration)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  return {
    isMobile,
    path,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionStateDescription,
  saveActionDurationValueAfter,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultichannelActionValueAfterDurationEnhanced = enhance

export default withRouter(SelectMultichannelActionValueAfterDurationEnhanced)
